import { Box } from '@mui/material'
import Dot from './Dot'

function LoadingDot() {
    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            <Dot animationDelay="0s" />
            <Dot animationDelay="0.5s" />
            <Dot animationDelay="1s" />
        </Box>
    )
}
export default LoadingDot
